<div>
  @switch (status) {
    @case ('IN-PROGRESS') {
      <h5 class="theme-text-title-color">In Progress</h5>
    }
    @case ('PAST') {
      <button class="btn btn-theme-primary {{ buttonClass }}" routerLink="/results" [queryParams]="{c: contest.CompetitionId}" type="button">View Results</button>
    }
    @case ('REGISTER') {
      <button class="btn btn-theme-primary {{ buttonClass }}" (click)="goCheckout(contest.SessionId)" type="button">
        Register - {{ contest.Price ? (contest.Price | currency: 'USD' : 'symbol' : '1.0-0') : 'Free' }}
      </button>
    }
    @case ('REGISTER-CUSTOMER') {
      <h5 class="text-start text-md-center theme-text-title-color">Ask your parent!</h5>
    }
    @case ('REGISTER-FREE') {
      <button class="btn btn-theme-primary {{ buttonClass }}" (click)="goRegister()" type="button">
        @if (!isRegistering) {
          Register - Free
        }
        @else {
          <fa-icon class="me-2" [icon]="faSpinner" animation="spin"></fa-icon>Registering
        }
      </button>
    }
    @case ('REGISTERED') {
      <h5 class="theme-text-title-color">Registered</h5>
    }
    @case ('REGISTERED-COMING') {
      <h5 class="theme-text-title-color">Opens Soon!</h5>
    }
    @case ('REGISTERED-OVER') {
      <button class="btn btn-theme-primary {{ buttonClass }}" routerLink="/results" [queryParams]="{c: contest.CompetitionId}" type="button">View Results</button>
    }
    @case ('REGISTERED-RUNNING') {
      <button class="btn btn-theme-primary {{ buttonClass }}" routerLink="/contest" [queryParams]="{c: contest.CompetitionId}" type="button">Join</button>
    }
    @default {
      <fa-icon class="me-2" [icon]="faSpinner" animation="spin"></fa-icon>Loading
    }
  }
</div>
